require('./RADissociateObjectiveSuccess.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @utilities
const { FormattedText } = require('core/i18n').i18n;

const RADissociateObjectiveSuccess = props => {
    const {
        endDate,
        goalIcon,
        name,
        hasPeriodicity,
        portfolioTrackingUrl,
        productIcon,
        productName,
        strategyTrackingLink,
    } = props;

    let objectiveEndDateInfo;

    if (hasPeriodicity) {
        objectiveEndDateInfo = (
            <div className="ra-dissociate-objective-success__enddate-info">
                <OKMessage type="informative">
                    <p className="ra-dissociate-objective-success__enddate-text">
                        <FormattedText
                            value="raDissociateObjective-raDissociateObjective_objectiveEndDateText"
                            injectedStrings={[endDate]}
                        />
                    </p>
                </OKMessage>
            </div>
        );
    }

    return (
        <div className="row ra-dissociate-objective-success__container">
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 grid-view--fix-cell-separation">
                            <section className="content-box content-box--shadow content-box--wealth ra-dissociate-objective-success__info-section">
                                <div className="ra-dissociate-objective-success__icon-container">
                                    <div className="ra-dissociate-objective-success__objective-icon-container">
                                        <img
                                            className="ra-dissociate-objective-success__objective-icon no-print-out"
                                            src={goalIcon}
                                            alt=""
                                            aria-hidden
                                        />
                                    </div>
                                    <div className="ra-dissociate-objective-success__content-block-arrow">
                                        <i className="ra-dissociate-objective-success__content-block-icon icon-flecha-izquierda" />
                                    </div>
                                    <div className="ra-dissociate-objective-success__portfolio-icon-container">
                                        <div className={productIcon} />
                                    </div>
                                </div>
                                <div className="ra-dissociate-objective-success__info-content">
                                    <div className="ra-dissociate-objective-success__info-content-header">
                                        <FormattedText
                                            value="raDissociateObjective-raDissociateObjective_dissociatedObjectiveDetailsText"
                                            injectedStrings={[
                                                name,
                                                productName,
                                            ]}
                                        />
                                    </div>
                                    <div className="ra-dissociate-objective-success__info-content-text">
                                        <FormattedText value="raDissociateObjective-raDissociateObjective_dissociateObjectiveSuccessBody" />
                                    </div>
                                    <div className="ra-dissociate-objective-success__info-content-strategytext">
                                        <FormattedTextWithComponents
                                            value="raDissociateObjective-raDissociateObjective_strategyRenameText"
                                            injectedComponents={[
                                                strategyTrackingLink,
                                            ]}
                                        />
                                    </div>
                                </div>
                                {objectiveEndDateInfo}
                            </section>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 ra-dissociate-objective-success__disclaimer-container">
                            <OKMessage type="informative" modifier="dark-bg">
                                <p className="ra-dissociate-objective-success__disclaimer-header">
                                    <FormattedText value="raDissociateObjective-raDissociateObjective_objectiveRemovalInfoText" />
                                </p>
                            </OKMessage>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="ra-dissociate-objective-success__ctabutton-container">
                                <OKButton
                                    to={portfolioTrackingUrl}
                                    modifier="secondary"
                                >
                                    <FormattedText value="raDissociateObjective-raDissociateObjective_portfolioTrackingLinkText" />
                                </OKButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

RADissociateObjectiveSuccess.propTypes = {
    mappingBreadcrumb: PropTypes.array.isRequired,
    headingTitle: PropTypes.string.isRequired,
    goalIcon: PropTypes.string.isRequired,
    isSubmitSuccessful: PropTypes.bool.isRequired,
    productName: PropTypes.string.isRequired,
    productIcon: PropTypes.string.isRequired,
    portfolioTrackingUrl: PropTypes.string,
    hasPeriodicity: PropTypes.bool,
    endDate: PropTypes.string,
    name: PropTypes.string.isRequired,
    strategyTrackingLink: PropTypes.string.isRequired,
};

RADissociateObjectiveSuccess.defaultProps = {
    hasPeriodicity: false,
    endDate: '',
};

module.exports = RADissociateObjectiveSuccess;
